import React from 'react';
import { motion } from 'framer-motion';

function Banner({ title, subtitle, classes }) {
  return (
    <div className="pt-[260px] pb-[140px] relative bg-black overflow-hidden">
      <motion.div
        className="banner_text my-[20px] mx-auto max-w-[1000px] text-center p-[40px] z-10 relative"
        initial={{
          opacity: 0,
          x: -50,
        }}
        whileInView={{
          opacity: 1,
          x: 0,
          transition: {
            duration: 1,
          },
        }}
        viewport={{ once: true }}
      >
        <h1 className='font-medium mb-8 text-[9.5vw] sm:text-[50px] tracking-wider text-white'>{title}</h1>
        <p className='text-white max-w-[700px] my-0 mx-auto mb-8'>{subtitle}</p>
      </motion.div>
      <div className="banner-img"></div>
    </div>
  );
}

export default Banner;
